import classNames from 'classnames';
import { isNumber } from 'lodash';
import React__default from 'react';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';

var css_248z = "/*! rtl:begin:ignore */.DKQmP{background:rgba(0,0,0,.5);height:100%;position:relative;width:100%}.jnii7{animation:YRl5N 1.7s ease infinite,_1J0s- 1.7s ease infinite;border-radius:50%;bottom:0;color:#fbfbfb;font-size:60px;height:1em;left:0;margin:auto;position:absolute;right:0;top:0;width:1em}.jnii7.iRC6u{font-size:40px}.jnii7._4XYXg{font-size:20px}.edCP9{border-radius:50%;bottom:0;color:#fbfbfb;font-size:60px;height:1.5em;left:0;margin:auto;position:absolute;right:0;text-align:center;top:0;width:3em}.edCP9.iRC6u{font-size:16px}.edCP9._4XYXg{font-size:12px}.wDxhk{height:100%;width:100%}@keyframes _1J0s-{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes YRl5N{0%{box-shadow:0 -.83em 0 -.4em,0 -.83em 0 -.42em,0 -.83em 0 -.44em,0 -.83em 0 -.46em,0 -.83em 0 -.477em}5%,95%{box-shadow:0 -.83em 0 -.4em,0 -.83em 0 -.42em,0 -.83em 0 -.44em,0 -.83em 0 -.46em,0 -.83em 0 -.477em}10%,59%{box-shadow:0 -.83em 0 -.4em,-.087em -.825em 0 -.42em,-.173em -.812em 0 -.44em,-.256em -.789em 0 -.46em,-.297em -.775em 0 -.477em}20%{box-shadow:0 -.83em 0 -.4em,-.338em -.758em 0 -.42em,-.555em -.617em 0 -.44em,-.671em -.488em 0 -.46em,-.749em -.34em 0 -.477em}38%{box-shadow:0 -.83em 0 -.4em,-.377em -.74em 0 -.42em,-.645em -.522em 0 -.44em,-.775em -.297em 0 -.46em,-.82em -.09em 0 -.477em}to{box-shadow:0 -.83em 0 -.4em,0 -.83em 0 -.42em,0 -.83em 0 -.44em,0 -.83em 0 -.46em,0 -.83em 0 -.477em}}\n/*! rtl:end:ignore */";
var styles = {"loaderOverlay":"DKQmP","loader":"jnii7","load6":"YRl5N","spinner":"_1J0s-","medium":"iRC6u","mini":"_4XYXg","progress":"edCP9","preview_img":"wDxhk"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const styleLoader = {
  position: "absolute",
  top: "0"
};
function createFakeProgressStepper(onProgress, approximateExpectedDuration = 5e3) {
  let lastTimeoutId;
  let progress = 0;
  const startDate = Date.now();
  const getTimeoutDelay = () => {
    const linearStep = approximateExpectedDuration / 100;
    if (progress <= 25) {
      return linearStep / 4;
    } else if (progress <= 50) {
      return linearStep / 3;
    } else if (progress <= 90) {
      return linearStep / 1.5;
    } else {
      const timeRemaining = approximateExpectedDuration - (Date.now() - startDate);
      return timeRemaining / (100 - progress);
    }
  };
  const run = () => {
    progress += 1;
    if (progress >= 100) {
      return;
    }
    lastTimeoutId = setTimeout(run, getTimeoutDelay());
    onProgress(progress);
  };
  run();
  return () => {
    clearTimeout(lastTimeoutId);
  };
}
class Loader extends React__default.Component {
  constructor() {
    super(...arguments);
    this.state = { percent: 1 };
  }
  componentDidMount() {
    const { percent } = this.props;
    if (!isNumber(percent)) {
      let approximateExpectedDuration;
      if (this.props.isFastFakeLoader) {
        approximateExpectedDuration = 8500;
      }
      if (this.props.isVerySlowFakeLoader) {
        approximateExpectedDuration = 5e4;
      }
      this.resetFakeLoader = createFakeProgressStepper(
        (percent2) => this.setState({ percent: percent2 }),
        approximateExpectedDuration
      );
    }
  }
  componentWillUnmount() {
    this.resetFakeLoader && this.resetFakeLoader();
  }
  renderProgress() {
    const percent = isNumber(this.props.percent) ? this.props.percent : this.state.percent;
    return /* @__PURE__ */ React__default.createElement("div", null, /* @__PURE__ */ React__default.createElement(
      "div",
      {
        className: classNames(styles.progress, {
          [styles[this.props.type]]: this.props.type
        })
      },
      `${percent}%`
    ));
  }
  render() {
    const style = this.state.localUrl ? __spreadProps(__spreadValues({}, styleLoader), { backgroundImage: `url(${this.state.localUrl})` }) : styleLoader;
    return /* @__PURE__ */ React__default.createElement("div", { className: classNames(styles.loaderOverlay), "data-hook": "loader", style }, /* @__PURE__ */ React__default.createElement(
      "div",
      {
        className: classNames(styles.loader, {
          [styles[this.props.type]]: this.props.type
        })
      }
    ), this.props.disableProgress ? null : this.renderProgress());
  }
}
Loader.defaultProps = {
  type: "mini",
  isFastFakeLoader: true
};

export { Loader as default };
//# sourceMappingURL=Loader.js.map
